import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { MsalProvider } from '@azure/msal-react'
import { PublicClientApplication } from '@azure/msal-browser'
import reportWebVitals from './reportWebVitals'
import { msalConfig } from './authConfig'
import { frontendDirection, frontendLocale } from './i18n'

document.documentElement.lang = frontendLocale
document.documentElement.dir = frontendDirection

const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
  )
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  )
})
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
